import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { FaSortAmountUp, FaSortAmountDown, FaCheck, FaStopwatch, FaUserShield, FaChevronUp, FaChevronDown, FaArrowRight, FaArrowLeft } from 'react-icons/fa';
import Sidebar from '../dashboard/sidebar';
import Navbar from '../dashboard/navbar';
import useAuth from '../dashboard/useAuth';
import axios from 'axios';
import { Table, Modal, Button, Form, ProgressBar, DropdownButton } from 'react-bootstrap';
import { getAuthToken } from '../../authToken';

const Eligibilites_soumises = () => {
    useAuth(); // Authentication required

    const [eligibilites, setEligibilites] = useState([]);
    const [filteredEligibilites, setFilteredEligibilites] = useState([]);
    const [selectedEligibilite, setSelectedEligibilite] = useState(null);
    const [searchTerm, setSearchTerm] = useState('');
    const [sortConfig, setSortConfig] = useState({ key: 'date_modification', direction: 'descending' });
    const [currentStatus, setCurrentStatus] = useState(''); // État pour le statut
    const [showInfo, setShowInfo] = useState(false);

    const [showUserModal, setShowUserModal] = useState(false);
    const [users, setUsers] = useState([]);
    const [selectedUserId, setSelectedUserId] = useState(null);
    const [selectedUserEmail, setSelectedUserEmail] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [isLoadingPage, setIsLoadingPage] = useState(false);


    const [userSearchTerm, setUserSearchTerm] = useState('');

    const filteredUsers = users.filter(user =>
        user.email.toLowerCase().includes(userSearchTerm.toLowerCase())
    );



    const [alert, setAlert] = useState({ message: '', type: '' });
    const showAlert = (message, type = 'success') => {
        setAlert({ message, type });
    };

    const fermerNotif = () => {
        setAlert({ message: '', type: '' });
    }

    // Fonction pour ouvrir le modal et charger les utilisateurs

const handleOpenUserModal = async () => {
    try {
        setIsLoading(true);

        const token = localStorage.getItem('access_token');

        // Envoi au backend
        const response = await fetch(`${process.env.REACT_APP_HOTE}/liste-utilisateurs/`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
        });
        
        const data = await response.json(); // Récupérer les données JSON
        
        // Vérifier la structure de la réponse
        if (Array.isArray(data)) {
            setUsers(data);
        } else if (data && data.utilisateurs && Array.isArray(data.utilisateurs)) {
            setUsers(data.utilisateurs);
        } else if (data && data.data && Array.isArray(data.data)) {
            setUsers(data.data);
        } else {
            console.error("Format de réponse inattendu:", data);
            setUsers([]); // Initialiser à un tableau vide pour éviter l'erreur
            showAlert("Format de données inattendu de l'API", "danger");
        }
        
        setShowUserModal(true);
    } catch (error) {
        console.error("Erreur lors du chargement des utilisateurs", error);
        setUsers([]); // Initialiser à un tableau vide en cas d'erreur
        showAlert("Erreur lors du chargement des utilisateurs", "danger");
    } finally {
        setIsLoading(false);
    }
};

    // Fonction pour migrer l'éligibilité
    const handleMigrateEligibilite = async () => {
        if (!selectedUserId) {
            showAlert("Veuillez sélectionner un utilisateur");
            return;
        }

        setIsLoading(true);
        try {
            // 1. Migration
            const token = localStorage.getItem('access_token');

            let response = await fetch(
                `https://testapi-etrainapp.ivtapp.com/migrer-eligibilite/`,
                // `${process.env.REACT_APP_HOTE}/migrer-eligibilite/`,
                {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${token}`
                    },
                    body: JSON.stringify({ email: selectedUserEmail }),
                }
            );
            if (!response.ok) {
                const err = await response.json().catch(() => null);
                throw { source: 'migrer-eligibilite', error: err?.error || response.statusText };
            }
            const eligibilityData = await response.json();

            // 2. Soumission

            response = await fetch(
                `${process.env.REACT_APP_HOTE}/soumettre-eligibilite/${selectedUserId}/`,
                {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${token}`
                    },
                    body: JSON.stringify({
                        ...eligibilityData.eligibilite,
                        experiences: eligibilityData.experiences,
                    }),
                }
            );
            if (!response.ok) {
                const err = await response.json().catch(() => null);
                throw { source: 'soumettre-eligibilite', error: err?.error || response.statusText };
            }

            showAlert("Migration effectuée avec succès !");
            setShowUserModal(false);

        } catch (error) {
            console.error("Erreur complète:", error);
            if (error.source === 'migrer-eligibilite') {
                showAlert(`Erreur lors de la récupération : ${error.error}`);
            } else if (error.source === 'soumettre-eligibilite') {
                showAlert(`Erreur lors de la soumission : ${error.error}`);
            } else {
                showAlert(`Erreur inattendue: ${error.message || error}`);
            }
        } finally {
            setIsLoading(false);
            fetchEligibilites()
        }
    };


    // Pagination state
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const totalItems = eligibilites.length;  // Si 'formationList' contient toutes les formations

    const navigate = useNavigate();
    const user_id = localStorage.getItem('user_id');


    // Utilisation de useEffect pour mettre à jour le titre de la page
    useEffect(() => {
        if (user_id) {
            document.title = "eTrainApp | Eligibilite"; // Définit le titre de la page
        }
    }, [user_id]);


    const fetchEligibilites = async () => {
        setIsLoadingPage(true)
        try {
            const token = localStorage.getItem('access_token');

            const response = await fetch(`${process.env.REACT_APP_HOTE}/liste-eligibilites/`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
            });
            // const response = await fetch(`${process.env.REACT_APP_HOTE}/liste-eligibilites/`);
            if (response.ok) {
                const data = await response.json();
                setEligibilites(data);
                setFilteredEligibilites(data);
            } else {
                console.error('Erreur lors de la récupération des éligibilités');
            }
        } catch (error) {
            console.error('Erreur réseau:', error);
        } finally {
            setIsLoadingPage(false)
        }
    };

    useEffect(() => {

        fetchEligibilites();
    }, []);

    const handleSort = (key) => {
        let direction = 'ascending';
        if (sortConfig.key === key && sortConfig.direction === 'ascending') {
            direction = 'descending';
        }
        setSortConfig({ key, direction });
    };


    const parseDate = (dateString) => {
        const [day, month, year] = dateString.split('-').map(Number); // Sépare et convertit chaque partie
        return new Date(year, month - 1, day); // Les mois sont 0-indexés en JavaScript
    };


    const sortedEligibilites = [...filteredEligibilites].sort((a, b) => {
        let aValue = a[sortConfig.key];
        let bValue = b[sortConfig.key];

        // Si la clé est une date, on convertit avant de comparer
        if (sortConfig.key === 'date_soumission' || sortConfig.key === 'date_modification') {
            aValue = parseDate(aValue);
            bValue = parseDate(bValue);

            // Si une des dates est invalide, on la considère comme infinie
            if (isNaN(aValue)) aValue = sortConfig.direction === 'ascending' ? Infinity : -Infinity;
            if (isNaN(bValue)) bValue = sortConfig.direction === 'ascending' ? Infinity : -Infinity;
        }

        if (aValue < bValue) {
            return sortConfig.direction === 'ascending' ? -1 : 1;
        }
        if (aValue > bValue) {
            return sortConfig.direction === 'ascending' ? 1 : -1;
        }
        return 0;
    });



    const handleRowClick = (eligibilite) => {
        setSelectedEligibilite(eligibilite);
    };

    const handleExaminerClick = () => {
        if (selectedEligibilite) {
            localStorage.setItem("utilisateur_id", selectedEligibilite.utilisateur_id);
            navigate(`/Eligibilite-admin`);
        }
    };

    // Met à jour le filtrage basé sur le terme de recherche et le statut actuel
    useEffect(() => {
        const results = eligibilites.filter(eligibilite =>
            (eligibilite.nom_utilisateur || '').toLowerCase().includes(searchTerm.toLowerCase()) ||
            (eligibilite.prenoms_utilisateur || '').toLowerCase().includes(searchTerm.toLowerCase()) ||
            (eligibilite.date_soumission || '').toLowerCase().includes(searchTerm.toLowerCase()) ||
            (eligibilite.date_modification || '').toLowerCase().includes(searchTerm.toLowerCase()) ||
            (eligibilite.statut || '').toLowerCase().includes(searchTerm.toLowerCase()) ||
            eligibilite.date_soumission.includes(searchTerm)
        ).filter(eligibilite => {
            return currentStatus ? eligibilite.statut === currentStatus : true; // Filtrer par statut
        });
        setFilteredEligibilites(results);
    }, [searchTerm, eligibilites, currentStatus]); // Ajouter currentStatus ici

    // Pagination logic
    const indexOfLastEligibilite = currentPage * itemsPerPage;
    const indexOfFirstEligibilite = indexOfLastEligibilite - itemsPerPage;
    const currentEligibilites = sortedEligibilites.slice(indexOfFirstEligibilite, indexOfLastEligibilite);
    const totalPages = Math.ceil(sortedEligibilites.length / itemsPerPage);

    const handleItemsPerPageChange = (e) => {
        setItemsPerPage(Number(e.target.value));
        setCurrentPage(1); // Reset to the first page
    };

    const handlePrevPage = () => {
        if (currentPage > 1) setCurrentPage(currentPage - 1);
    };

    const handleNextPage = () => {
        if (currentPage < totalPages) setCurrentPage(currentPage + 1);
    };

    // Gestionnaires de clic pour les boutons de filtrage
    const handleFilterClick = (status) => {
        setCurrentStatus(status);
        setCurrentPage(1); // Reset to the first page lors du changement de filtre
    };

    // Compte le nombre d'éligibilités par statut
    const countStatus = () => {
        return eligibilites.reduce((acc, eligibilite) => {
            acc[eligibilite.statut] = (acc[eligibilite.statut] || 0) + 1;
            return acc;
        }, {});
    };

    const statusCounts = countStatus();


    // Fonction pour définir le style en fonction du statut
    const getStatutStyle = (statut) => {
        switch (statut) {
            case 'valide':
                return 'badge badge-primary';
            case 'en attente':
                return 'badge badge-success';
            case 'a revoir':
                return 'badge badge-warning';
            default:
                return {};
        }
    };

    // Fonction pour définir l'émoticône en fonction du statut
    const getStatutEmoticone = (statut) => {
        switch (statut) {
            case 'valide':
                return '✅'; // Émoticône pour validé
            case 'en attente':
                return '⏳'; // Émoticône pour en attente
            case 'a revoir':
                return '❌'; // Émoticône pour à revoir
            default:
                return '';
        }
    };

    const [accesGroupe, setAccesGroupe] = useState([]);
    const [groupeId, setGroupeId] = useState(null);
    const groupe = localStorage.getItem('groupe');

    const verifGroupe = async () => {
        const groupeStored = localStorage.getItem('groupe');
        const accesGroupeStored = localStorage.getItem('accesGroupe');

        if (groupeStored && accesGroupeStored) {
            setGroupeId(groupeStored);
            setAccesGroupe(JSON.parse(accesGroupeStored));
        } else {
            try {
                const response = await axios.get(`${process.env.REACT_APP_HOTE}/verif-groupe/${user_id}/${groupe}`);
                if (response.status === 200) {
                    const data = response.data;
                    setGroupeId(data.groupe);

                    let cleanedAccessArray = [];
                    if (Array.isArray(data.acces)) {
                        cleanedAccessArray = data.acces.map((item) =>
                            item.acces
                                ? item.acces.replace(/[\[\]']/g, '').trim().split(',').map((access) => access.trim())
                                : []
                        ).flat();

                        setAccesGroupe(cleanedAccessArray);
                    }

                    localStorage.setItem('groupe', data.groupe);
                    localStorage.setItem('accesGroupe', JSON.stringify(cleanedAccessArray));
                }
            } catch (error) {
                // console.error('Erreur lors de la vérification du groupe', error);
            }
        }
    };

    useEffect(() => {
        if (user_id) {
            verifGroupe();
        }
    }, [user_id]);

    if (!accesGroupe.includes("AdminEligibilite")) {
        return (
            <div id="wrapper">
                <Sidebar user_id={user_id} />
                <div id="page-wrapper" className="gray-bg">
                    <Navbar />
                    <div className="wrapper wrapper-content animated fadeInRight">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="ibox">
                                    <div className="ibox-content text-center p-5">
                                        <div className="mb-4">
                                            <i className="fa fa-lock fa-5x text-warning"></i>
                                        </div>
                                        <h2>Accès restreint</h2>
                                        <p className="lead mb-4">
                                            Vous n'avez pas les autorisations nécessaires pour accéder à cette page.
                                        </p>
                                        <div className="d-flex justify-content-center">
                                            <Link to="/" className="btn btn-primary">
                                                <i className="fa fa-arrow-left mr-2"></i>
                                                Retour
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }


    return (
        <div id="wrapper">
            <Sidebar user_id={user_id} titre="Éligibilités soumises" />
            <div id="page-wrapper" className="gray-bg">
                <Navbar />
                <div>
                    <div className="row wrapper border-bottom white-bg page-heading">
                        <div className="d-flex flex-column col-lg-12">
                            <div className="justify-content-between align-items-center statuts">
                                <div>
                                    <h2 className="d-flex align-items-center">
                                        <FaUserShield size={25} className="mr-2" />
                                        Eligibilité
                                        <span
                                            className="ml-3 toggle-icon"
                                            style={{ cursor: 'pointer' }}
                                            onClick={() => setShowInfo(!showInfo)}
                                        >
                                            {showInfo ? <FaChevronUp /> : <FaChevronDown />}
                                        </span>
                                    </h2>
                                    <div className={`info-box ${showInfo ? "open" : ""}`}>
                                        <small>Administration des Eligibilités.</small><br />
                                        <small><b>Légende : </b>
                                            <span className='badge badge-primary'>Valide</span> <span>Le dossier d'éligibilité a été validé par l'administrateur.  </span>
                                            <span className='badge badge-warning' >A revoir</span> <span>Le dossier d'éligibilité a été renvoyé par l'administrateur pour correction. </span>
                                            <span className='badge badge-success'>En attente</span> <span>Le dossier d'éligibilité a été soumis par l'utilisateur.</span>
                                        </small>
                                    </div>
                                </div>

                                {/* Affichage des comptes de statut ici */}

                                <div className="col-md-6 w-100">
                                    <div className="row d-flex justify-content-between">
                                        {/* En attente */}
                                        <div className="col-4 col-md-4">
                                            <div className="widget bg-success text-right">
                                                <span>En Attente</span>
                                                <h2 className="font-bold">{statusCounts['en attente'] || 0}</h2>
                                            </div>
                                        </div>

                                        {/* A Reprendre */}
                                        <div className="col-4 col-md-4">
                                            <div className="widget bg-success text-right">
                                                <span>A Revoir</span>
                                                <h2 className="font-bold">{statusCounts['a revoir'] || 0}</h2>
                                            </div>
                                        </div>

                                        {/* Validé */}
                                        <div className="col-4 col-md-4">
                                            <div className="widget bg-success text-right">
                                                <span>Déja Validé</span>
                                                <h2 className="font-bold">{statusCounts['valide'] || 0}</h2>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <small id='hbreadcrumb' className='d-flex justify-content-end mr-3'>
                                <ol className="breadcrumb custom-breadcrumb">
                                    <li className="breadcrumb-item custom-breadcrumb-item">
                                        {/* Utiliser Link de react-router-dom pour la navigation */}
                                        <Link to={`/admin`}> Administration</Link>
                                    </li>
                                    <li className="breadcrumb-item custom-breadcrumb-item">
                                        <Link to={`/eligibilites-soumises`}>Eligibilité</Link>
                                    </li>
                                </ol>
                            </small>
                        </div>

                    </div>



                    <div className="wrapper wrapper-content animated fadeInRight mt-3">
                        <div className="d-flex justify-content-between align-items-center mb-3">
                            <div className='d-flex align-items-center'>
                                <h5 style={{ marginRight: '20px' }}>Liste des éligibilités </h5>

                                <select style={{ border: '1px black solid', borderRadius: '5px' }} onChange={(e) => handleFilterClick(e.target.value)} className="btn btn-light ms-2 mr-2">
                                    <option className="btn btn-light text-left" value="">Tout</option>
                                    <option className="btn btn-light text-left" value="en attente">En attente</option>
                                    <option className="btn btn-light text-left" value="a revoir">A revoir</option>
                                    <option className="btn btn-light text-left" value="valide">Validé</option>
                                </select>
                            </div>
                            <div>
                                <button
                                    onClick={handleExaminerClick}
                                    disabled={!selectedEligibilite}
                                    className={`btn ms-2 mr-2 ${selectedEligibilite ? 'btn-success' : 'btn-default btn-border text-dark disabled'}`}
                                >
                                    Examiner
                                </button>
                                <button
                                    onClick={handleOpenUserModal}
                                    className="btn btn-success ms-2"
                                >
                                    Migrer éligibilité
                                </button>
                            </div>
                        </div>

                        <div className='ibox-content'>
                            <div className="d-flex justify-content-between align-items-center mb-3">
                                <select
                                    value={itemsPerPage}
                                    onChange={handleItemsPerPageChange}
                                    className="form-select bg-default p-1 me-2" // Utiliser me-2 pour l'espacement
                                    style={{ border: '1px black solid', borderRadius: '5px', width: 'auto' }}
                                >
                                    <option value={10}>10</option>
                                    <option value={20}>20</option>
                                    <option value={50}>50</option>
                                </select>

                                <input
                                    type="text"
                                    placeholder="Rechercher..."
                                    className="form-control"
                                    style={{ maxWidth: '150px', width: '100%' }} // Largeur fixe ou maximale selon besoin
                                    value={searchTerm}
                                    onChange={(e) => setSearchTerm(e.target.value)}
                                />
                            </div>
                            <div className="table-responsive" style={{ fontSize: '11px' }}>
                                <table className="footable table table-stripped footable-loaded tablet breakpoint" data-page-size="8" data-filter="#filter">
                                    <thead>
                                        <tr>
                                            <th className='text-secondary text-wrap d-none d-md-table-cell' onClick={() => handleSort('nom_utilisateur')}>
                                                Nom {sortConfig.key === 'nom_utilisateur'}{sortConfig.direction === 'ascending' ? <FaSortAmountUp /> : <FaSortAmountDown />}
                                            </th>
                                            <th className='text-secondary text-wrap d-none d-md-table-cell' onClick={() => handleSort('prenoms_utilisateur')}>
                                                Prénoms {sortConfig.key === 'prenoms_utilisateur'}{sortConfig.direction === 'ascending' ? <FaSortAmountUp /> : <FaSortAmountDown />}
                                            </th>
                                            <th className='text-secondary text-wrap d-none d-md-table-cell' onClick={() => handleSort('date_soumission')}>
                                                Date de soumission {sortConfig.key === 'date_soumission'}{sortConfig.direction === 'ascending' ? <FaSortAmountUp /> : <FaSortAmountDown />}
                                            </th>
                                            <th className='text-secondary text-wrap d-none d-md-table-cell' onClick={() => handleSort('date_modification')}>
                                                Dernière modification {sortConfig.key === 'date_modification'}{sortConfig.direction === 'ascending' ? <FaSortAmountUp /> : <FaSortAmountDown />}
                                            </th>
                                            <th className='text-secondary text-wrap d-none d-md-table-cell' onClick={() => handleSort('statut')}>
                                                Statut {sortConfig.key === 'statut'}{sortConfig.direction === 'ascending' ? <FaSortAmountUp /> : <FaSortAmountDown />}
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {isLoadingPage ? (
                                            <tr>
                                                <td colSpan="5" className="text-center">
                                                    <div className="mt-3 d-flex justify-content-center align-items-center">
                                                        <div className="spiner-example">
                                                            <div className="sk-spinner sk-spinner-wave">
                                                                <div className="sk-rect1 mr-1"></div>
                                                                <div className="sk-rect2 mr-1"></div>
                                                                <div className="sk-rect3 mr-1"></div>
                                                                <div className="sk-rect4 mr-1"></div>
                                                                <div className="sk-rect5"></div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </td>
                                            </tr>
                                        ) : currentEligibilites.length > 0 ? (
                                            currentEligibilites.map((eligibilite) => (
                                                <tr
                                                    key={eligibilite.id}
                                                    onClick={() => handleRowClick(eligibilite)}
                                                    className={`bg-white ${selectedEligibilite && selectedEligibilite.id === eligibilite.id ? 'bg-success text-white' : ''}`}
                                                >
                                                    <td>
                                                        {eligibilite.nom_utilisateur}
                                                        <div className='lesInfos'>
                                                            <small>Prénoms : {eligibilite.prenoms_utilisateur}</small><br />
                                                            <small>Date de soumission : {eligibilite.date_soumission}</small><br />
                                                            <small>Date de modification : {eligibilite.date_modification}</small><br />
                                                            <small>Statut : {eligibilite.statut}</small>
                                                        </div>
                                                    </td>
                                                    <td className="d-none d-md-table-cell">{eligibilite.prenoms_utilisateur}</td>
                                                    <td className="d-none d-md-table-cell">{eligibilite.date_soumission}</td>
                                                    <td className="d-none d-md-table-cell">{eligibilite.date_modification}</td>
                                                    <td className="d-none d-md-table-cell">
                                                        <span className={getStatutStyle(eligibilite.statut)} style={{ textTransform: 'capitalize' }}>
                                                            {eligibilite.statut}
                                                        </span>
                                                    </td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan="5" className="text-center">Aucune éligibilité trouvée</td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                            <div className="d-flex justify-content-between align-items-center mt-3">
                                <div className="dataTables_info" role="status" aria-live="polite">
                                    {totalItems === 0
                                        ? "Aucun élément à afficher"
                                        : `Élément ${indexOfFirstEligibilite + 1} à ${Math.min(indexOfLastEligibilite, totalItems)} sur ${totalItems}`}
                                </div>
                                <div>
                                    <button
                                        onClick={() => setCurrentPage(currentPage > 1 ? currentPage - 1 : 1)}
                                        className="btn btn-light mx-1"
                                        disabled={currentPage === 1}
                                    >
                                        <FaArrowLeft />
                                    </button>

                                    {(() => {
                                        const pagesToShow = 5; // Nombre total de pages à afficher
                                        let startPage = Math.max(1, currentPage - Math.floor(pagesToShow / 2));
                                        let endPage = Math.min(totalPages, startPage + pagesToShow - 1);

                                        // Ajuster le startPage si la fin dépasse le total des pages
                                        if (endPage - startPage < pagesToShow - 1) {
                                            startPage = Math.max(1, endPage - pagesToShow + 1);
                                        }

                                        const pageButtons = [];

                                        // Ajout des boutons de pages
                                        for (let i = startPage; i <= endPage; i++) {
                                            pageButtons.push(
                                                <button
                                                    key={i}
                                                    onClick={() => setCurrentPage(i)}
                                                    className={`btn ${currentPage === i ? 'btn-default' : 'btn-light'} mx-1`}
                                                >
                                                    {i}
                                                </button>
                                            );
                                        }

                                        return pageButtons;
                                    })()}

                                    <button
                                        onClick={() => setCurrentPage(currentPage < totalPages ? currentPage + 1 : totalPages)}
                                        className="btn btn-light mx-1"
                                        disabled={currentPage === totalPages}
                                    >
                                        <FaArrowRight />
                                    </button>

                                    {/* Bouton pour aller à la dernière page */}
                                    <button
                                        onClick={() => setCurrentPage(totalPages)}
                                        className="btn btn-light mx-1"
                                        disabled={currentPage === totalPages}
                                    >
                                        {totalPages}
                                    </button>
                                </div>
                            </div>
                        </div>
                        {/* Modal pour sélectionner l'utilisateur */}
                        <Modal show={showUserModal} onHide={() => setShowUserModal(false)} size="lg">
                            <Modal.Header className="border-0 pb-0">
                                <Modal.Title className="h4 text-primary">
                                    Migrer une éligibilité
                                </Modal.Title>
                            </Modal.Header>

                            {alert.message && (
                                <div className={`alert alert-${alert.type} row justify-content-between position-relative m-3`}>
                                    <div dangerouslySetInnerHTML={{ __html: alert.message }} />
                                    <span
                                        onClick={fermerNotif}
                                        style={{
                                            position: 'absolute',
                                            top: '0px',
                                            right: '10px',
                                            cursor: 'pointer'
                                        }}
                                    >
                                        <i className='fa fa-close'></i>
                                    </span>
                                </div>
                            )}

                            <Modal.Body className="pt-4">
                                {isLoading ? (
                                    <div className="text-center py-5">
                                        <div className="spinner-border text-primary" role="status" style={{ width: '3rem', height: '3rem' }}></div>
                                    </div>
                                ) : (
                                    <>
                                        <div className="mb-4">
                                            <p className="text-muted mb-2">
                                                Sélectionnez l'utilisateur destination pour la migration
                                            </p>
                                            <div className="input-group">
                                                {/* <span className="input-group-text">
                            <i className="fa fa-search"></i>
                        </span> */}
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="Rechercher par email..."
                                                    value={userSearchTerm}
                                                    onChange={(e) => setUserSearchTerm(e.target.value)}
                                                />
                                            </div>
                                        </div>

                                        <div className="table-responsive rounded" style={{ maxHeight: '400px', overflowY: 'auto' }}>
                                            <table className="table table-hover align-middle">
                                                <thead className="table-light sticky-top">
                                                    <tr>
                                                        <th style={{ width: '25%' }}>Nom</th>
                                                        <th style={{ width: '25%' }}>Prénom</th>
                                                        <th style={{ width: '35%' }}>Email</th>
                                                        <th style={{ width: '15%' }} className="text-center">Action</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {filteredUsers.length > 0 ? (
                                                        filteredUsers.map(user => (
                                                            <tr key={user.id} className={selectedUserId === user.id ? 'table-active' : ''}>
                                                                <td className="fw-medium">{user.nom}</td>
                                                                <td>{user.prenoms}</td>
                                                                <td>
                                                                    <span className="text-truncate d-inline-block" style={{ maxWidth: '100%' }}>
                                                                        {user.email}
                                                                    </span>
                                                                </td>
                                                                <td className="text-center">
                                                                    {selectedUserId === user.id ? (
                                                                        <span className="badge bg-success">
                                                                            <FaCheck />
                                                                        </span>
                                                                    ) : (
                                                                        <button
                                                                            className="btn btn-sm btn-outline-primary"
                                                                            onClick={() => {
                                                                                setSelectedUserId(user.id);
                                                                                setSelectedUserEmail(user.email);
                                                                            }}
                                                                        >
                                                                            Sélectionner
                                                                        </button>
                                                                    )}
                                                                </td>
                                                            </tr>
                                                        ))
                                                    ) : (
                                                        <tr>
                                                            <td colSpan="4" className="text-center py-4">
                                                                Aucun utilisateur trouvé
                                                            </td>
                                                        </tr>
                                                    )}
                                                </tbody>
                                            </table>
                                        </div>
                                    </>
                                )}
                            </Modal.Body>

                            <Modal.Footer className="border-0 pt-0">
                                <button
                                    className="btn btn-outline-secondary me-2"
                                    onClick={() => setShowUserModal(false)}
                                >
                                    Annuler
                                </button>
                                <button
                                    className="btn btn-primary"
                                    onClick={handleMigrateEligibilite}
                                    disabled={!selectedUserId || isLoading}
                                >
                                    {isLoading ? (
                                        <>
                                            <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                            Migration...
                                        </>
                                    ) : (
                                        <>
                                            Migrer l'éligibilité
                                        </>
                                    )}
                                </button>
                            </Modal.Footer>
                        </Modal>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Eligibilites_soumises;
